import { createFileRoute, Outlet } from "@tanstack/react-router";

// The "Fundraising" title and Donors/Donations subnav were removed from this
// shared layout — each child page now owns its own header. Compliance, Page
// Builder, Settings and Call Time are reached via the sidebar (Your Donors).
export const Route = createFileRoute("/_app/_/fundraising")({
	component: FundraisingLayout,
});

function FundraisingLayout() {
	return <Outlet />;
}
